<!-- 本月巡检任务 -->
<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
      </div>
    </div>
    <div class="m-panel-body">
      <div class="base-box">
        <div class="base-item" v-for="item in list" :key="item.title">
          <div class="base-text">
            <div class="title">{{item.title}}</div>
            <div class="num"><i>{{item.num}}</i></div>
          </div>
          <div class="base-img">
            <img src="@/assets/images/waterPay/top-right.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    postAction
  } from '@/api/manage'
  export default {
    data() {
      return {
        title: this.$t('本月巡检任务'),
        url: {
          LargeScreenSumMonth:"/jeecg-engineering/inspection/inspectionTask/LargeScreenSumMonth"
        },
        list: [
          {title:this.$t('计划巡检'),num:0},
          {title:this.$t('实际巡检'),num:0},
          {title:this.$t('计划保养'),num:0},
          {title:this.$t('实际保养'),num:0},
        ]
      }
    },
    mounted() {},
    methods: {
      init() {
        this.getData();
      },
      getData(){
        postAction(this.url.LargeScreenSumMonth,{queryType:2}).then(res=>{
          if(res.success){
            var data = res.result;
            this.list[0].num = data.inspectionPlanNum;
            this.list[1].num = data.inspectionFinishNum;
            this.list[2].num = data.maintenancePlanNum;
            this.list[3].num = data.maintenanceFinishNum;
          }
        })
      }
    },
  }
</script>
<style lang="less" scoped>
  .base-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    height: 100%;

    .base-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 45%;
      height: 50%;
      position: relative;

      .base-img {
        width: 80%;
        height: 120%;
        position: relative;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .base-text {
        text-align: center;
        font-size: 18px;
        z-index: 99;
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
        
        .num{
          font-size: 25px;
          font-family: fantasy;
        }
      }
    }
  }
</style>